import Footer from 'components/footer/Footer';
import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { Header } from 'components/header/Header';
import './SuccessPage.css';
import { profilesApiRoot as apiRoot } from 'app/config';

function useQuery() {
  return new URLSearchParams(useLocation().search);
}

export default function SuccessPage() {
  const [paymentInfo, setPaymentInfo] = useState(null);
  const [email, setEmail] = useState(null);
  const [onboardingData, setOnboardingData] = useState(null);
  const [toast, setToast] = useState({ message: '', type: '' });
  const [showToast, setShowToast] = useState(false);


  const query = useQuery();
  const ref = query.get("ref");





  useEffect(() => {
    const storedData = localStorage.getItem("formStep2Data");
    if (storedData) {
      try {
        setOnboardingData(JSON.parse(storedData));
      } catch (e) {
        console.error("Invalid onboardingData in localStorage", e);
      }
    }
  }, []);

  const triggerToast = (message, type = 'success') => {
    setToast({ message, type });
    setShowToast(true);

    setTimeout(() => {
      setShowToast(false);
    }, 5000);
  };

  useEffect(() => {
    const fetchPaymentData = async () => {
      if (!ref) return;

      try {
        const response = await fetch(`${apiRoot}/organizations/stripepayments/get?userId=${ref}`, {
          method: "GET",
          headers: { "Accept": "application/json" }
        });

        const contentType = response.headers.get("content-type");
        if (!contentType || !contentType.includes("application/json")) {
          throw new Error("Expected JSON, got: " + contentType);
        }

        const data = await response.json();
        console.log("Raw payment data from API:", data);
        if (Array.isArray(data) && data.length > 0) {
          setPaymentInfo(data[0]);
        } else {
          console.error("Stripe payment API returned empty or invalid data:", data);
        }
      } catch (error) {
        console.error("Error fetching payment info:", error);
      }
    };

    fetchPaymentData();
  }, [ref]);

  useEffect(() => {
    const postOnboardData = async () => {
      console.log(paymentInfo);
      console.log(onboardingData);
      if (!paymentInfo || !onboardingData) return;

      const {
        customer,
        createdAt,
        expiredAt,
        paymentStatus
      } = paymentInfo;

      const combinedPayload = {
        ...onboardingData,
        customerId: customer,
        paymentStartDate: createdAt,
        paymentEndDate: expiredAt,
        paymentStatus
      };

      console.log("Sending onboardUserData payload:", combinedPayload);

      try {
        const response = await fetch(`${apiRoot}/organizations/onboardorgUserdata`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "Accept": "application/json"
          },
          body: JSON.stringify(combinedPayload)
        });

        if (!response.ok) {
          throw new Error(`HTTP ${response.status}`);
        }

        const result = await response.json();
        console.log("onboardUserData response:", result);
        triggerToast("Your onboarding has been completed successfully!", "success");
        localStorage.setItem('registrationCompleted', 'true');
        localStorage.removeItem("formStep2Data");
        localStorage.removeItem("formStep1Data");
        localStorage.removeItem("registeredUserId");
      } catch (error) {
        console.error("Error calling onboardUserData:", error);
      }
    };

    postOnboardData();
  }, [paymentInfo, onboardingData]);

  useEffect(() => {
    const email = localStorage.getItem("email");
    if (email) {
      setEmail(email);
    }
  }, []);


  return (
    <div>
      <div className="header">
        <Header />
      </div>
      <div className="success-container">
        <div className="success-box">
          {showToast && (
            <div className={`custom-toast show ${toast.type}`}>
              {toast.message}
            </div>
          )}
          <div className="success-icon">✅</div>
          <h4 className="success-text">
            Thanks for your payment
            <br />
            Welcome to Calcium <br />
            We're excited to have you onboard
          </h4>
          {email && (
            <p className="support-note">
              We've sent a confirmation email to{" "}
              <a href={`mailto:${email.trim().replace(/^"+|"+$/g, '')}`}>
                {email.trim().replace(/^"+|"+$/g, '')}
              </a> <br />
              Be sure to complete your email confirmation. <br />
              Please check your Spam or Junk folder if you haven’t received the email in your inbox.
            </p>
          )}
          <p className="support-note">
            Need help? Contact <a href="mailto:support@calciumhealth.com"><br />support@calciumhealth.com</a>
          </p>
        </div>
      </div>
      <div>
        <Footer />
      </div>
    </div>
  );
}
